import { BaseModal } from "../components/common/BaseModal/BaseModal";
import { useUiTranslator } from "../hooks/useUiTranslator";
import { useAdministrationArea } from "../providers/administrationAreaProvider";

import { JSX } from "react";

import { Box, Button, Typography } from "@mui/material";

import { useEnsureQuoteExists } from "./useEnsureQuoteExists";

export function AdministrationAreaFetchError(): JSX.Element {
  const t = useUiTranslator();
  const { refetchAdministrationArea } = useAdministrationArea();
  const { refetch: refetchQuote } = useEnsureQuoteExists();

  function handleRetry(): void {
    refetchAdministrationArea();
    refetchQuote();
  }

  return (
    <BaseModal
      title={t(
        "CustomApp:dialog.administrationAreaError.header",
        "Connection issue",
      )}
      isOpen={true}
      onClose={() => {}}
      hideClose={true}
    >
      <Typography variant="body1" sx={{ maxWidth: "24em" }}>
        {t(
          "CustomApp:dialog.administrationAreaError.body",
          "We couldn't verify your administration area. Please check your connection and try again.",
        )}
      </Typography>
      <Box display="flex" justifyContent="flex-end" pt={4}>
        <Button variant="contained" onClick={handleRetry}>
          {t("CustomApp:btn.retry", "Retry")}
        </Button>
      </Box>
    </BaseModal>
  );
}
